import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
    margin-left: ${props => props.marginLeft}px;
    margin-top: ${props => props.marginTop}px;
    height: ${props => props.bottom ? `calc(100vh - ${props.marginTop}px - 52px)` : `calc(100vh - ${props.marginTop}px)`};
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
`

export default ({children, marginTop, mobile, ...props}) => (
    <Wrapper marginLeft={mobile ? 0 : global.SIDE_BAR_SMALL_WIDTH} marginTop={marginTop} id='wrapper' {...props}>
        {children}
    </Wrapper>
)
